// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"1e64b161","431":"7ea4d3f8","489":"661ffe65","507":"54bdc494","608":"1ca815cc","787":"a6fcdfb2","845":"202529eb","880":"2cf5461f"}[chunkId] + ".chunk.js";
};